// extracted by mini-css-extract-plugin
module.exports = {"primary-color":"#3d9ae2","gray":"#d4d5de","text-dark":"#1C2657","mobile-content-side-margin":"20px","border-radius":"10px"};